<template>
  <div :class="{card: !isIndividual}">
    <div class="card-header" v-if="!isIndividual">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">EBIT / (NWC + NFA) > 0</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'ebitnwcnfa'" :fileName="'ebitnwcnfaGt0'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb-15" v-if="isIndividual">
        <div class="col-md-9">
          <!-- <strong class="card-title mb-3">EBIT / (NWC + NFA) > 0</strong> -->
        </div>
        <div class="col-md-3">
          <download :tableId="'ebitnwcnfa'" :fileName="'ebitnwcnfaGt0'"></download>
        </div>
      </div>
      <div class="row mb-15">
        <div class="col-md-9 br">
          <filtersMrkt
            ref="mrkFilt"
            :dDate="ddate"
            @filter="filtData"
            @filterDate="filtDate"
            :filterOptions="filterOptions"
          ></filtersMrkt>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selRangeFilter" @change="filterRangeData($event)">
              <option
                v-for="(d, index) in mcOptions"
                v-bind:key="d.id+index"
                :value="index"
              >{{d.value}}</option>
            </select>
          </div>
          <!-- <mcfilter :rawData="rawData" :searchData="searchData" @updateRawData="updaterdata"> </mcfilter> -->
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true" >
        <table
          id="ebitnwcnfa"
          class="table table-bordered fonts11 app-inner"
          
        >
          <thead>
            <tr>
              <!-- <th>Sr.</th> -->
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rawData" v-bind:key="'row'+row+index">
              <!-- <td>{{index+1}}</td> -->
              <td v-for="field in tableFields" v-bind:key="'td'+field.title+index">
                <span v-if="field.isLink">
                  <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                </span>
                <span
                  v-else
                >{{(field.isNumeric && field.title !=='rank')? getFixed(row[field.title]): row[field.title]}}</span>
                <!-- {{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}} -->
              </td>
            </tr>
          </tbody>
        </table> 
        <div class="alert alert-danger" role="alert" v-if="rawData.length===0">No data found!</div>       
      </div>
      <!-- <div class="row" v-else>
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">No data found!</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { mrktCommonMixins } from "../../assets/mixins/mrktcommon.js";

export default {
  mixins: [commonMixins, mrktCommonMixins],
  props: ["isIndividual"],
  created() {
    this.getRawData();
  },
  data() {
    return {
      ddate: "", //new Date().setDate(new Date().getDate() - 1),
      tableFields: [
        {
          title: "rank",
          name: "Rank",
          isNumeric: true,
          sort_order: "",
          isLink: 0,
          isSortable: 1
        },
        {
          title: "co_code",
          name: "Company Code",
          isNumeric: false,
          sort_order: "",
          isLink: 0,
          isSortable: 1
        },
        {
          title: "companyname",
          name: "Company",
          isNumeric: false,
          sort_order: "",
          isLink: 1,
          isSortable: 1
        },
        {
          title: "marketCapitalization_latest",
          name: "Market Cap (Latest)",
          isNumeric: true,
          sort_order: "",
          isLink: 0,
          isSortable: 1
        },
        {
          title: "ebit_per_net_working_capital_plus_nfa",
          name: "EBIT (NWC+NFA)",
          isNumeric: true,
          sort_order: "",
          isLink: 0,
          isSortable: 1
        }
      ],
      rawDataList: [],
      rawDataApi: "getAllEbitPerWorkingDataGtZero",
      rawData: {},
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: "",
      maxRange: "",
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        },
        {
          id: "marketCapitalization_latest",
          value: "Market Cap (Latest)",
          isNumeric: true,
          sort_order: 0
        },
        {
          id: "ebit_per_net_working_capital_plus_nfa",
          value: "EBIT (NWC+NFA)",
          isNumeric: true,
          sort_order: 0
        }
      ],
      selFilter: "",
      selRangeFilter: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ]
    };
  },
  methods: {
    //Filter Data on Market cap range
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          console.log(
            rd.marketCapitalization_latest,
            this.selRangeFilter,
            minRange,
            maxRange
          );
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange) &&
              parseInt(rd["marketCapitalization_latest"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange)
              );
            }
            if (maxRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) <=
                parseInt(maxRange)
              );
            }
          }
        });
      }
      setTimeout(() => {
        this.sortColumn(this.tableFields[2], 2);
      });
    },
    filtData(obj) {
      console.log("Filter", obj, JSON.stringify(obj));
      // this.ddate = new Date(obj.durDate);
      this.minRange = obj.min;
      this.maxRange = obj.max;
      this.selFilter = obj.selField;
      this.filterData();
    },
    clearData() {
      // this.selRangeFilter = 0;
      // this.selFilter = "";
      this.searchText = "";
      this.rawData = this.searchData;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/ebitNwcNfaGtZero.vue